import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Asset from "../../../containers/modules/accounting/asset";

export default function AssetRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="asset"
      index
      element={
        <AccessControl
          name={"Asset List"}
          auth={authUser}
          component={() => <Asset />}
        />
      }
    />
  );
}
